import { DEADLINE } from '@/constants/deadline'

export function getDeadlineColorByName(name: string) {
  const iterable = Object.values(DEADLINE)
  const found = iterable.find((item) => item.name === name)
  if (found) {
    return found.color
  }

  return ''
}
